import { Col, Row } from 'antd';
import React, { useState, useEffect, useRef } from 'react'
import { FaUpload, FaDownload, FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { LoadingButton, PrimaryButton } from '../../custom_components/customButton';
import { colorScheme } from '../../contants/variables';
import { error as errorSnackbar } from '../../contants/snackbars';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import JSZipUtils from 'jszip-utils';
import { download, downloadBicycleImages, uploadImage, deleteImage } from '../../stores/api_calls/upload';
import * as FileDownload from 'js-file-download'
import axios from 'axios';
import CustomFileInput from '../CustomFileInput';
import Validator from '../../stores/utils/validator';

const UploadBicycleImages = (props) => {

    const { isEdit, selectedFiles, setSelectedFiles, form, setForm, noOfImages, initialImageIds } = props;
    const [downloading, setDownloading] = useState(false)
    const [enableUploader, setEnableUploader] = useState(true);

    const updateSlot = (id, patch) => {
        setSelectedFiles((previous) =>
            previous.map((image) =>
                image.imageIndex === id ? { ...image, ...patch } : image
            )
        );
    };

    // Uploads immediately on selection; the slot only ever holds the
    // uploaded image's _id and S3 url — never a File object.
    const handleUploadImage = async (e, id) => {
        if (e.target.files.length) {
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];  // Define the allowed file types
            const allowedExtensions = ['jpg', 'jpeg', 'png'];  // Define the allowed file extensions
            const maxSizeInMB = 10; // Maximum file size in megabytes

            const file = e.target.files[0];
            const { value, error } = new Validator(file).ImageFileType(allowedTypes).ImageFileExtension(allowedExtensions).FileSize(maxSizeInMB);
            if (error) {
                errorSnackbar(error);
                return;
            }

            const slotIndex = selectedFiles.findIndex(image => image.imageIndex === id);
            if (slotIndex === -1) return;

            updateSlot(id, { _id: "", url: "", uploading: true });

            try {
                // Provisional 1-based order; the authoritative order is the
                // product_image_id array sent when the ad is posted.
                const res = await uploadImage(file, slotIndex + 1, true, form.direct_seller);
                const data = res?.data?.data;

                if (data?._id) {
                    updateSlot(id, {
                        _id: data._id,
                        url: data?.metadata?.image_url ?? "",
                        uploading: false,
                    });
                } else {
                    throw new Error("Upload failed");
                }
            } catch (err) {
                updateSlot(id, { _id: "", url: "", uploading: false });
                errorSnackbar(err?.response?.data?.server_response ?? "Image upload failed. Please try again.");
            }
        }
    };

    const onRemoveImage = (val, imgUrl) => {
        const slot = selectedFiles.find(image => image.imageIndex === val);
        if (!slot) return;

        // Only images uploaded in this session are deleted on the server.
        // Images already attached to the listing are just blanked locally —
        // the update endpoint unassigns them on submit, so cancelling the
        // edit doesn't destroy a live listing's image.
        if (slot._id && !(initialImageIds ?? []).includes(slot._id)) {
            deleteImage(slot._id).catch(() => {
                errorSnackbar("Failed to remove the image from the server.");
            });
        }

        updateSlot(val, { _id: "", url: "", uploading: false });
    };

    // Swap the image payload (_id/url) with the adjacent slot; the grid
    // position (imageIndex/orderNo) stays fixed.
    const onMoveImage = (index, direction) => {
        const targetIndex = index + direction;
        if (targetIndex < 0 || targetIndex >= selectedFiles.length) return;

        setSelectedFiles((previous) => {
            const updated = [...previous];
            const source = updated[index];
            const target = updated[targetIndex];

            updated[index] = { ...source, _id: target._id, url: target.url, uploading: target.uploading };
            updated[targetIndex] = { ...target, _id: source._id, url: source.url, uploading: source.uploading };

            return updated;
        });
    };

    const handleDownload = () => {
        setDownloading(true)
        const dl = downloadBicycleImages(form.id)
        dl.then((response) => {
            console.log("Download Response: ", response)
            if (response) {
                FileDownload(response.data, `${form.product_name.replaceAll(" ", "_")}.zip`);
            }
            setDownloading(false);
        }).catch(e => {
            console.log(e)
            setDownloading(false);
        })

        // const zip = JSZip();
        // var count = 0;
        // var zipFilename = `${form.carName.replaceAll(" ","")}.zip`;  
        // urls.forEach(function (url, i) {
        //     var filename = `${form.carName.replaceAll(" ","")}_${i+1}.png`;
        //     //   console.log(filename)
        //     // var cors_api_host = 'crossorigin.me/';
        //     var cors_api_host = 'cors-anywhere.herokuapp.com';
        //     var cors_api_url = `https://${cors_api_host}/${url}`;

        //     JSZipUtils.getBinaryContent(url, function (err, data) {
        //         if (err) {
        //         throw err;
        //         }
        //         zip.file(filename, data, { binary: true });
        //         count++;
        //         if (count == urls.length) {
        //         zip.generateAsync({ type: 'blob' }).then(function (content) {
        //             FileSaver.saveAs(content, zipFilename);
        //         });
        //         }
        //     });
        // });
    }

    return (
        <div>
            <div
                className='upload-header'
            >
                <div className='header-div'>
                    <p className='header-text'>Upload Pictures</p>
                    <p className='sub-header-text'>
                        Upload requirements: You can upload upto 9 images. Total image file size should not exceed <span style={{ color: 'red', fontWeight: 'bold' }}>10MB </span>
                        and it's dimension should not exceed (4800 x 3600)pixels.
                        <span style={{ color: 'red', fontWeight: 'bold' }}> Please noted that only PNG & JPG images are allowed.</span>
                    </p>
                </div>
            </div>
            {isEdit ?
                <div>
                    <div
                        className='upload-header'
                    >
                        <div className='header-div'>
                            <p className='header-text'>Upload Images</p>
                        </div>
                        {isEdit ?
                            <div className='download-div'>
                                {downloading ?
                                    <LoadingButton label="Downloading Images" />
                                    : <PrimaryButton onClick={handleDownload} color={colorScheme.green} label="Download All Image" Icon={<FaDownload style={{ marginRight: '10px' }} />} />
                                }
                            </div>
                            : null}

                    </div>
                </div>
                : null
            }
            {/* {error.isError ? <p className='upload-error-text'>{error.message}</p> : ""} */}

            <Row gutter={[20, 20]}>
                {
                    selectedFiles.length > 0 &&
                    selectedFiles.map(({ imageIndex, url, uploading }, index) =>
                        <Col span={8} key={imageIndex}>
                            {uploading ? (
                                <div
                                    style={{
                                        height: '200px',
                                        border: '2px dashed #808080',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <p>Uploading...</p>
                                </div>
                            ) : (
                                <CustomFileInput
                                    id={imageIndex}
                                    handleUploadImage={handleUploadImage}
                                    imgUrl={url}
                                    onRemoveImage={onRemoveImage}
                                />
                            )}
                            {url !== "" && !uploading && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginTop: '8px',
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => onMoveImage(index, -1)}
                                        disabled={index === 0}
                                        style={{ cursor: index === 0 ? 'not-allowed' : 'pointer', padding: '4px 12px' }}
                                        title="Move image left"
                                    >
                                        <FaArrowLeft />
                                    </button>
                                    <span style={{ alignSelf: 'center', fontWeight: 'bold' }}>{index + 1}</span>
                                    <button
                                        type="button"
                                        onClick={() => onMoveImage(index, 1)}
                                        disabled={index === selectedFiles.length - 1}
                                        style={{ cursor: index === selectedFiles.length - 1 ? 'not-allowed' : 'pointer', padding: '4px 12px' }}
                                        title="Move image right"
                                    >
                                        <FaArrowRight />
                                    </button>
                                </div>
                            )}
                        </Col>
                    )
                }
            </Row>
        </div>
    )
}

export default UploadBicycleImages
